import { breakpoints } from '../constants'
import { useMatchMedia } from './use-match-media'

export const useScrollTopValue = () => {
    const matchesLg = useMatchMedia(breakpoints.lg)
    const matchesSm = useMatchMedia(breakpoints.sm)
    if (matchesLg) {
        return 290
    }
    if (matchesSm) {
        return 180
    }

    return 160
}
